import tierQueries from '@apis/queries/tierQueries';
import useProject from '@hooks/useProject';
import { useQuery } from '@tanstack/react-query';

function useTier() {
    const project = useProject();
    const { data, isSuccess } = useQuery({
        ...tierQueries.tier(),
        enabled: !!project?.features.tierEnabled,
    });
    return { data, isSuccess };
}

export default useTier;
